import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import SupervisorBanquesConnecteResults from './SupervisorBanquesConnecteResults';
import SupervisorGroupCodeField from '../../components/SupervisorGroupCodeField';
import LotteryCodeField from '../../components/LotteryCodeField';
import DateField from '../../components/DateField';
import { todayISO } from '../../utils/date';
import './SupervisorBanquesConnectePage.css';

// Variante superviseur (2026-09-16) de pages/central/BanquesConnectePage.jsx —
// pas de radio Tout/Groupe/Superviseur (le superviseur n'a jamais eu l'option
// Bank sur cette page cote company non plus) : la portee est toujours SES
// banks, avec un champ "Groupe" optionnel (2026-09-17), meme UI/UX que la
// company (texte + icone 🔍 + modal, pas de <select>). Champs sans effet
// reel meme cote company (Refresh Every, Zone ID, Division ID) retires.
const SupervisorBanquesConnectePage = () => {
  const [showResults, setShowResults] = useState(false);
  const [groupId, setGroupId] = useState('');
  const [groupName, setGroupName] = useState('');

  const [lottery, setLottery] = useState('0');
  const [lotteryName, setLotteryName] = useState('');
  const [date, setDate] = useState(todayISO());
  const [statut, setStatut] = useState('Tout');
  const [inColumn, setInColumn] = useState(false);
  const [offlineMinutes, setOfflineMinutes] = useState('5');

  const handleSearch = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  if (showResults) {
    return (
      <SupervisorBanquesConnecteResults
        lottery={lottery}
        groupId={groupId}
        date={date}
        statut={statut}
        inColumn={inColumn}
        offlineMinutes={offlineMinutes}
        onBack={() => setShowResults(false)}
      />
    );
  }

  return (
    <SupervisorLayout>
      <p className="svbc-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svbc-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/central" className="svbc-link">Central</Link>
        {' >> '}
        <Link to="/supervisor/banques-connecte" className="svbc-link">Banques Connecte</Link>
      </p>

      <div className="svbc-card">
        <div className="svbc-card-header">
          <span className="svbc-card-title">Monitoring de la Banque</span>
        </div>
        <div className="svbc-card-body">
          <form onSubmit={handleSearch} className="svbc-form">
            <div className="svbc-row">
              <label className="svbc-label">Loterie</label>
              <LotteryCodeField
                value={lottery}
                name={lotteryName}
                onChange={(code) => { setLottery(code); setLotteryName(''); }}
                onResolve={(code, nm) => { setLottery(code); setLotteryName(nm); }}
                inputClass="svbc-input svbc-input-sm"
                iconClass="svbc-icon svbc-icon-btn"
                nameClass="svbc-scope-name"
              />
            </div>

            <div className="svbc-row">
              <label className="svbc-label">Date</label>
              <DateField className="svbc-input svbc-input-date" value={date} onChange={setDate} />
              <label className="svbc-label svbc-label-gap">Groupe</label>
              <SupervisorGroupCodeField
                value={groupId}
                name={groupName}
                onChange={(id) => { setGroupId(id); setGroupName(''); }}
                onResolve={(id, nm) => { setGroupId(id); setGroupName(nm); }}
                inputClass="svbc-input svbc-input-sm"
                iconClass="svbc-icon svbc-icon-btn"
                nameClass="svbc-scope-name"
              />
            </div>

            <div className="svbc-row">
              <label className="svbc-label">Statut de la Banque</label>
              <select className="svbc-select" value={statut} onChange={(e) => setStatut(e.target.value)}>
                <option value="Tout">Tout</option>
                <option value="En ligne">En ligne</option>
                <option value="Deconnecte">Deconnecte</option>
                <option value="N'a pas connecte">N'a pas connecte</option>
              </select>
              <label className="svbc-label svbc-label-gap svbc-checkbox-label">
                Dans une colonne
                <input type="checkbox" checked={inColumn} onChange={(e) => setInColumn(e.target.checked)} />
              </label>
            </div>

            <div className="svbc-row">
              <label className="svbc-label svbc-label-wide">Minutes a considerer une banque comme deconnecte</label>
              <input
                className="svbc-input svbc-input-sm"
                type="text"
                value={offlineMinutes}
                onChange={(e) => setOfflineMinutes(e.target.value)}
              />
              <span className="svbc-unit">Mins</span>
            </div>

            <button type="submit" className="svbc-search-btn">Chercher</button>
          </form>
        </div>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorBanquesConnectePage;
